"use strict";

var SponsorshipHelper = require("../sponsorshipComponents/SponsorshipHelper");
var ActionsHelper = require("../actions/ActionsHelper");

var SimpleDropdownFromWizard = require("../commonComponents/SimpleDropdownFromWizard");
var singleEditSponsorshipSelector = "[data-component='mySponsorships.populated.singleSponsorship.edit']";

var MySponsorshipsEditFrequencySelector = React.createClass({
	propTypes: {
		childClass: React.PropTypes.string,
		context: React.PropTypes.string,
		dataComponentId: React.PropTypes.string,
		dataNestedId: React.PropTypes.string,
		dataRepeatedId: React.PropTypes.string,
		frequencies: React.PropTypes.object,
		isCustomTheme: React.PropTypes.bool,
		isDesignMode: React.PropTypes.bool,
		reactComponentCategory: React.PropTypes.string,
		required: React.PropTypes.bool,
		theme: React.PropTypes.string
	},

	handleFrequencySelected: function (event) {
		if (!event || !event.currentTarget) {
			return;
		}

		var $editSponsorship = $(event.currentTarget).closest(singleEditSponsorshipSelector);
		var amount = SponsorshipHelper.calculateUpdatedTotalForMySponsorships($editSponsorship, event.currentTarget.value);

		this.updateSponsorshipAmountComponent(amount, $editSponsorship);
	},

	updateSponsorshipAmountComponent(amount, $element) {
		// update the component UI to make sure that the SD amount matches what's in the store.
		var $component = $element.find(`[data-dynamic="AmountPerGift"]`);
		if ($component) {
			var formattedAmount = ActionsHelper.formatAmount(amount, $component, /*keepDecimals*/ false);

			$component.text(formattedAmount);
		}
	},

	getInitialState() {
		//Can only edit if the initial Frequency is Monthly, Annually, Semi-annually or quarterly or we are in design mode
		return {
			canEdit: this.props.initialValue === "M" || this.props.initialValue === "A" || this.props.initialValue === "S" || this.props.initialValue === "Q" || this.props.isDesignMode
		};
	},

	render: function () {
		return (
			<SimpleDropdownFromWizard
				{...this.props}
				disabled={!this.state.canEdit}
				thisArg={this}
				config={this.props.frequencies} /*Needs to be frequencies because the FrequencyPropertyMap is hard-coded to this*/
				onChange={this.handleFrequencySelected}
				wizard={window.ProjectStore.get("wizardFrequencies")}
				wizardValuesKey="allowedFrequencies"
				configKey="availableFrequencies"
				reactComponentCategory="MySponsorshipsEditFrequencySelector"
				reactComponentName="MySponsorshipsEditFrequencySelector"
				selectClassName="frequency-selector"
				optionsClassName="availableFrequency"
				selectNameAttribute="frequency"
				hideEmptyOption={true}
			/>
		);
	}
});

module.exports = MySponsorshipsEditFrequencySelector;



// WEBPACK FOOTER //
// ./Javascript/accountComponents/MySponsorshipsEditFrequencySelector.jsx